<!-- Loading state -->
<div *ngIf="isLoading" style="padding: 40px; text-align: center; color: #6b7280;">
    Loading trip details...
  </div>
  
  <div class="main-wrapper" *ngIf="!isLoading">
    <div class="page-wrapper">
      <div class="content">
        <div class="trip-view-content">
  
          <!-- Title Row -->
          <div class="order-title-row">
            <div>
              <h4 class="order-title">{{ order?.orderNumber }} &mdash; {{ order?.customerName }}</h4>
              <div class="order-subtitle" *ngIf="order?.source || order?.destination">
                {{ order?.source }} - {{ order?.destination }}
              </div>
            </div>
            <div class="title-actions">
              <span class="badge mode-badge" *ngIf="isReadOnly">🔒 Read Only</span>
              <a href="javascript:void(0)" class="back-link" (click)="goBack()">Back</a>
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 1: Arrival Details
          ══════════════════════════════════════ -->
  
          <!-- Editable version: END_TRIP / ADD_POD -->
          <div class="card-section" *ngIf="!isReadOnly">
            <div class="section-header">
              <span class="step-badge">1</span>
              <h5>Arrival Details</h5>
            </div>
  
            <div class="section-body">
              <div class="form-grid">
  
                <div class="form-field">
                  <label>Reporting Date &amp; Time <span class="required">*</span></label>
                  <input
                    type="datetime-local"
                    class="form-control editable"
                    [(ngModel)]="arrivalReportingDateTime" />
                </div>
  
                <div class="form-field">
                  <label>Unloading Date &amp; Time <span class="required">*</span></label>
                  <input
                    type="datetime-local"
                    class="form-control editable"
                    [(ngModel)]="arrivalUnloadingDateTime" />
                </div>
  
              </div>
  
              <!-- Days calculation banner -->
              <div class="info-banner" *ngIf="arrivalReportingDateTime && arrivalUnloadingDateTime">
                🕐 <b>{{ tripDays }} {{ tripDays === 1 ? 'day' : 'days' }}</b> &middot; {{ tripDaysLabel }}
              </div>
            </div>
          </div>
  
          <!-- Read-only version: SHOW_POD -->
          <div class="card-section" *ngIf="isReadOnly">
            <div class="section-header">
              <span class="step-badge">1</span>
              <h5>Arrival Details</h5>
              <span class="read-only-badge">🔒 Read only</span>
            </div>
  
            <div class="section-body">
              <div class="form-grid">
                <div class="form-field">
                  <label>Reporting Date &amp; Time</label>
                  <input type="text" class="form-control" [value]="formatApiDate(tripData?.reportingDateTime)" readonly />
                </div>
                <div class="form-field">
                  <label>Unloading Date &amp; Time</label>
                  <input type="text" class="form-control" [value]="formatApiDate(tripData?.unloadingDateTime)" readonly />
                </div>
              </div>
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 2: POD Details
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header">
              <span class="step-badge">2</span>
              <h5>POD Details</h5>
              <span class="read-only-badge" *ngIf="isReadOnly">🔒 Read only</span>
            </div>
  
            <div class="section-body">
  
              <!-- Saved PODs — shown in every mode -->
              <div class="info-banner" *ngIf="savedPods.length === 0 && !savedPodsLoading">
                📬 No PODs saved yet<span *ngIf="!isReadOnly">. Add one below.</span>
              </div>
  
              <div class="repeatable-block" *ngFor="let pod of savedPods">
                <div class="repeatable-header">
                  <span class="repeatable-title">{{ pod.podType }} Copy POD</span>
                  <span class="badge" [ngClass]="podStatusClass(pod.status)">{{ pod.status }}</span>
                </div>
  
                <div class="form-grid">
                  <div class="form-field">
                    <label>POD Date</label>
                    <input type="text" class="form-control" [value]="formatApiDate(pod.podDate)" readonly />
                  </div>
  
                  <div class="form-field" *ngIf="pod.podType === 'Soft'">
                    <label>Condition</label>
                    <input type="text" class="form-control" [value]="pod.isClean === 1 ? 'Clean' : 'Remark'" readonly />
                  </div>
  
                  <div class="form-field" *ngIf="pod.modeId">
                    <label>Mode</label>
                    <input type="text" class="form-control" [value]="modeName(pod.modeId)" readonly />
                  </div>
  
                  <div class="form-field">
                    <label>Document</label>
                    <div class="doc-field">
                      <span class="doc-empty" *ngIf="!pod.podUrl">No document</span>
                      <a class="doc-link" *ngIf="pod.podUrl" [href]="pod.podUrl" target="_blank" rel="noopener">📎 View Document</a>
                    </div>
                  </div>
                </div>
  
                <!-- Line items (remarks) -->
                <ng-container *ngIf="pod.lineItems?.length">
                  <div class="sub-section-header">
                    <span>📝</span>
                    <span>Remarks</span>
                  </div>
                  <div class="form-grid" *ngFor="let li of pod.lineItems">
                    <div class="form-field">
                      <label>Category</label>
                      <input type="text" class="form-control" [value]="categoryName(li.categoryId)" readonly />
                    </div>
                    <div class="form-field">
                      <label>Quantity</label>
                      <input type="text" class="form-control" [value]="li.quantity" readonly />
                    </div>
                    <div class="form-field">
                      <label>Amount (₹)</label>
                      <input type="text" class="form-control" [value]="li.amount || '--'" readonly />
                    </div>
                    <div class="form-field full" *ngIf="li.remarks">
                      <label>Comment</label>
                      <input type="text" class="form-control" [value]="li.remarks" readonly />
                    </div>
                  </div>
                </ng-container>
              </div>
  
              <!-- Everything below is the ADD/EDIT flow.
                   Hidden entirely in SHOW_POD (read-only) mode — no forms,
                   no upload controls, no save buttons. -->
              <ng-container *ngIf="!isReadOnly">
  
                <!-- POD CONDITION -->
                <div class="repeatable-block">
                  <div class="repeatable-header">
                    <span class="repeatable-title">POD Condition</span>
                  </div>
  
                  <div class="radio-group">
                    <div class="radio-options">
                      <label class="radio-option">
                        <input type="radio" name="podCond" [checked]="podCondition === 'CLEAN'"
                          (change)="podCondition = 'CLEAN'; podRemarks = [emptyRemark()]" />
                        ✅ Clean
                      </label>
                      <label class="radio-option">
                        <input type="radio" name="podCond" [checked]="podCondition === 'REMARK'"
                          (change)="podCondition = 'REMARK'" />
                        ⚠️ Remark
                      </label>
                    </div>
                  </div>
  
                  <!-- Remarks — only when REMARK selected -->
                  <ng-container *ngIf="podCondition === 'REMARK'">
                    <div class="sub-section-header">
                      <span>📝</span>
                      <span>Remarks</span>
                    </div>
  
                    <div class="repeatable-block" *ngFor="let remark of podRemarks; let i = index" style="background:#fff;">
                      <div class="repeatable-header">
                        <span class="repeatable-title">Remark {{ i + 1 }}</span>
                        <span
                          class="lhc-section-icon cursor-pointer"
                          *ngIf="podRemarks.length > 1"
                          (click)="removeRemark(i)">
                          ❌
                        </span>
                      </div>
  
                      <div class="form-grid">
                        <div class="form-field">
                          <label>Category <span class="required">*</span></label>
                          <select class="form-control editable" [(ngModel)]="remark.categoryId">
                            <option [ngValue]="null" disabled>Select category</option>
                            <option *ngFor="let cat of podCategoryList" [ngValue]="cat.id">{{ cat.name || cat.categoryName }}</option>
                          </select>
                        </div>
                        <div class="form-field">
                          <label>Quantity <span class="required">*</span></label>
                          <input type="number" class="form-control editable" [(ngModel)]="remark.quantity" placeholder="0" />
                        </div>
                        <div class="form-field">
                          <label>Amount (₹)</label>
                          <input type="number" class="form-control editable" [(ngModel)]="remark.amount" placeholder="0" />
                        </div>
                      </div>
  
                      <div class="form-grid">
                        <div class="form-field full">
                          <label>Comment <span class="optional-label">(optional)</span></label>
                          <textarea class="form-control editable" rows="2" [(ngModel)]="remark.remarks" placeholder="Optional notes..."></textarea>
                        </div>
                      </div>
                    </div>
  
                    <button type="button" class="btn btn-add" (click)="addRemark()">+ Add Another Remark</button>
                  </ng-container>
                </div>
  
                <!-- SOFT COPY POD -->
                <div class="repeatable-block">
                  <div class="repeatable-header">
                    <span class="repeatable-title">Soft Copy POD</span>
                  </div>
  
                  <div class="form-grid">
                    <div class="form-field">
                      <label>POD Date <span class="required">*</span></label>
                      <input type="date" class="form-control editable" [(ngModel)]="softPodDate" />
                    </div>
                    <div class="form-field">
                      <label>Upload Document</label>
                      <div class="file-upload-row">
                        <label class="file-upload-btn">
                          📎 Choose File
                          <input type="file" hidden accept="image/*,.pdf" (change)="onSoftPodFileSelected($event)" />
                        </label>
                        <span class="file-upload-status" *ngIf="softPodUploading">Uploading...</span>
                        <span class="file-upload-status success" *ngIf="!softPodUploading && softPodUrl">✓ Uploaded</span>
                        <span class="file-upload-status" *ngIf="!softPodUploading && !softPodUrl">No file chosen</span>
                      </div>
                    </div>
                  </div>
  
                  <div class="row-footer">
                    <button type="button" class="btn btn-purple" [disabled]="podSaving" (click)="savePodDetails()">
                      {{ podSaving ? 'Saving...' : 'Save POD Details' }}
                    </button>
                  </div>
                </div>
  
                <!-- HARD COPY POD -->
                <div class="repeatable-block">
                  <div class="repeatable-header">
                    <span class="repeatable-title">Hard Copy POD</span>
                  </div>
  
                  <!-- Tabs: Pending / Received / Lost -->
                  <div class="radio-group">
                    <div class="radio-options">
                      <label class="radio-option">
                        <input type="radio" name="hardPodTab" [checked]="hardPodTab === 'PENDING'" (change)="hardPodTab = 'PENDING'" />
                        ⏳ Pending
                      </label>
                      <label class="radio-option">
                        <input type="radio" name="hardPodTab" [checked]="hardPodTab === 'RECEIVED'" (change)="hardPodTab = 'RECEIVED'" />
                        ✅ Received
                      </label>
                      <label class="radio-option">
                        <input type="radio" name="hardPodTab" [checked]="hardPodTab === 'LOST'" (change)="hardPodTab = 'LOST'" />
                        ⚠️ Lost
                      </label>
                    </div>
                  </div>
  
                  <!-- Received -->
                  <div *ngIf="hardPodTab === 'RECEIVED'">
                    <div class="form-grid">
                      <div class="form-field">
                        <label>Mode <span class="required">*</span></label>
                        <select class="form-control editable" [(ngModel)]="hardPodMode">
                          <option [ngValue]="null" disabled>Select mode</option>
                          <option *ngFor="let m of podModeList" [ngValue]="m.id">{{ m.name || m.modeName }}</option>
                        </select>
                      </div>
                      <div class="form-field">
                        <label>Submission Date <span class="required">*</span></label>
                        <input type="date" class="form-control editable" [(ngModel)]="hardPodSubmissionDate" />
                      </div>
                    </div>
  
                    <div class="form-grid">
                      <div class="form-field">
                        <label>Upload Hard POD</label>
                        <div class="file-upload-row">
                          <label class="file-upload-btn">
                            📎 Choose File
                            <input type="file" hidden accept="image/*,.pdf" (change)="onHardPodFileSelected($event)" />
                          </label>
                          <span class="file-upload-status" *ngIf="hardPodUploading">Uploading...</span>
                          <span class="file-upload-status success" *ngIf="!hardPodUploading && hardPodUrl">✓ Uploaded</span>
                          <span class="file-upload-status" *ngIf="!hardPodUploading && !hardPodUrl">No file chosen</span>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <!-- Lost -->
                  <div *ngIf="hardPodTab === 'LOST'">
                    <div class="info-banner" style="background:#fff1f2; color:#be123c;">
                      ⚠️ <b>Lost POD reported.</b> Indemnity bond required from vendor.
                    </div>
  
                    <div class="radio-group" style="margin-top: 14px;">
                      <label class="radio-label">Indemnity Status <span class="required">*</span></label>
                      <div class="radio-options" style="flex-direction: column; gap: 10px;">
                        <label class="radio-option">
                          <input type="radio" name="indemnity" [checked]="indemnityStatus === 'RECEIVED'" (change)="indemnityStatus = 'RECEIVED'" />
                          Yes — Received
                        </label>
                        <label class="radio-option">
                          <input type="radio" name="indemnity" [checked]="indemnityStatus === 'PENDING'" (change)="indemnityStatus = 'PENDING'" />
                          No / Indemnity Pending — Not yet received from vendor.
                        </label>
                      </div>
                    </div>
                  </div>
  
                  <div class="row-footer">
                    <button type="button" class="btn btn-purple" [disabled]="hardPodSaving" (click)="saveHardPod()">
                      {{ hardPodSaving ? 'Saving...' : 'Save Hard POD' }}
                    </button>
                  </div>
                </div>
  
              </ng-container>
  
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 3: Additional Charges
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header between">
              <div class="d-flex align-items-center gap-2">
                <span class="step-badge">3</span>
                <h5>Additional Charges</h5>
                <span class="read-only-badge" *ngIf="isReadOnly">🔒 Read only</span>
              </div>
            </div>
  
            <div class="section-body">
  
              <!-- Saved charges — shown in every mode -->
              <div class="info-banner" *ngIf="savedCharges.length === 0 && !savedChargesLoading">
                💰 No additional charges{{ isReadOnly ? '' : ' added yet.' }}
              </div>
  
              <div class="repeatable-block" *ngFor="let sc of savedCharges">
                <div class="repeatable-header">
                  <span class="repeatable-title">{{ sc.chargeTypeName }}</span>
                  <span class="badge badge-green">₹{{ sc.charge }}</span>
                </div>
  
                <div class="form-grid">
                  <div class="form-field">
                    <label>Charged To</label>
                    <input type="text" class="form-control"
                      [value]="(sc.chargeToCustomer ? 'Customer' : '') + (sc.chargeToCustomer && sc.chargeToVendor ? ' & ' : '') + (sc.chargeToVendor ? 'Vendor' : '')"
                      readonly />
                  </div>
                  <div class="form-field" *ngIf="sc.chargeToVendor">
                    <label>Vendor Charge (₹)</label>
                    <input type="text" class="form-control" [value]="sc.vendorCharge" readonly />
                  </div>
                  <div class="form-field" *ngIf="sc.remarks">
                    <label>Remarks</label>
                    <input type="text" class="form-control" [value]="sc.remarks" readonly />
                  </div>
                  <div class="form-field">
                    <label>Document</label>
                    <div class="doc-field">
                      <span class="doc-empty" *ngIf="!sc.docUrl">No document</span>
                      <a class="doc-link" *ngIf="sc.docUrl" [href]="sc.docUrl" target="_blank" rel="noopener">📎 View</a>
                    </div>
                  </div>
                </div>
              </div>
  
              <!-- Charge form rows — hidden entirely in read-only mode -->
              <ng-container *ngIf="!isReadOnly">
                <div class="repeatable-block" *ngFor="let charge of charges; let ci = index">
                  <div class="repeatable-header">
                    <span class="repeatable-title">Add Charge</span>
                  </div>
  
                  <div class="form-grid">
                    <div class="form-field">
                      <label>Type</label>
                      <select class="form-control editable" [(ngModel)]="charge.chargeTypeId" (change)="onChargeTypeChange(charge, $event)">
                        <option [ngValue]="null" disabled>Select</option>
                        <option *ngFor="let ct of chargeTypeList" [ngValue]="ct.id">{{ ct.name || ct.chargeName }}</option>
                      </select>
                    </div>
                    <div class="form-field">
                      <label>Amount (₹) <span class="required">*</span></label>
                      <input type="number" class="form-control editable" [(ngModel)]="charge.charge" placeholder="0" />
                    </div>
                  </div>
  
                  <div class="form-grid">
                    <div class="form-field">
                      <label>Document <span class="optional-label">(optional)</span></label>
                      <div class="file-upload-row">
                        <label class="file-upload-btn">
                          📎 Choose File
                          <input type="file" hidden accept="image/*,.pdf" (change)="onChargeFileSelected($event, charge)" />
                        </label>
                        <span class="file-upload-status" *ngIf="charge.uploading">Uploading...</span>
                        <span class="file-upload-status success" *ngIf="!charge.uploading && charge.docUrl">✓ {{ charge.docUrl.split('/').pop() }}</span>
                        <span class="file-upload-status" *ngIf="!charge.uploading && !charge.docUrl">No file chosen</span>
                      </div>
                    </div>
                    <div class="form-field">
                      <label>Remarks <span class="optional-label">(optional)</span></label>
                      <input type="text" class="form-control editable" [(ngModel)]="charge.remarks" placeholder="Optional" />
                    </div>
                  </div>
  
                  <!-- Charge Allocation -->
                  <div class="radio-group">
                    <label class="radio-label">Charge Allocation <span class="required">*</span> — both can be selected if applicable</label>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input type="checkbox" [(ngModel)]="charge.chargeToCustomer" /> Charged to Customer
                      </label>
                      <label class="radio-option">
                        <input type="checkbox" [(ngModel)]="charge.chargeToVendor" /> Paid to Vendor
                      </label>
                    </div>
                  </div>
  
                  <!-- Vendor Charge — only when Paid to Vendor is checked -->
                  <div class="form-grid" *ngIf="charge.chargeToVendor">
                    <div class="form-field">
                      <label>Vendor Charge (₹) <span class="required">*</span></label>
                      <input type="number" class="form-control editable" [(ngModel)]="charge.vendorCharge" placeholder="0" />
                    </div>
                  </div>
  
                  <div class="row-footer">
                    <button type="button" class="btn btn-purple" [disabled]="charge.saving" (click)="saveCharge(charge)">
                      {{ charge.saving ? 'Saving...' : '+ Add Charge' }}
                    </button>
                  </div>
                </div>
              </ng-container>
  
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               CLOSE TRIP
          ══════════════════════════════════════ -->
          <ng-container *ngIf="!isReadOnly">
  
            <div class="info-banner" *ngIf="!canCloseTrip()">
              💡 <b>To close this trip, you need:</b> at least one saved POD
            </div>
  
            <div class="bottom-bar" *ngIf="canCloseTrip()">
              <button type="button" class="btn btn-purple" [disabled]="closingTrip" (click)="closeTrip()">
                {{ closingTrip ? 'Closing...' : '🚩 Close Trip' }}
              </button>
            </div>
  
          </ng-container>
  
        </div>
      </div>
    </div>
  </div>